import React from 'react';
import { ModalFormSection, ModalV2 } from 'components/common/modals';

// This modal is used in User and CustomerVehicle pages.
// Be aware for future changes that it might affect both pages.

const UserBillingModal = ({ isOpen, onClose, children, title, loading }) => {
  return (
    <ModalV2
      isOpen={isOpen}
      onClose={onClose}
      isLoading={loading}
      title={title}
    >
      <ModalFormSection>{children}</ModalFormSection>
    </ModalV2>
  );
};

export default UserBillingModal;
